<table class="ir-plugin-table" style="margin-bottom: 10px" *ngFor="let item of comments">
  <tr *ngIf="item.To && item.To >= 0">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationcomments.to-destination' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-ph1">{{ item.To | commentto }}</span>
      </p>
    </td>
  </tr>
  <tr *ngIf="item.Comment">
    <td class="th-plugin-line--subheader plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationcomments.comment' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <div
        *ngIf="item?.Comment"
        class="ir-plugin-values th-plugin-values angular-editor-view ir-ph1"
        [innerHtml]="item?.Comment"
      ></div>
    </td>
  </tr>
</table>
